var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_6581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4884 18.5334C12.185 18.3635 11.815 18.3635 11.5116 18.5334L6.8387 21.1491C6.0941 21.5659 5.20315 20.9186 5.36943 20.0816L6.41292 14.829C6.48069 14.4879 6.36636 14.1361 6.11101 13.9L2.1788 10.2639C1.55227 9.68457 1.89255 8.63716 2.73995 8.53666L8.05819 7.90592C8.40352 7.86496 8.70278 7.64754 8.84845 7.33176L11.092 2.4684C11.4494 1.69358 12.5506 1.69358 12.908 2.4684L15.1515 7.33176C15.2972 7.64754 15.5965 7.86496 15.9418 7.90592L21.26 8.53666C22.1074 8.63716 22.4477 9.68457 21.8212 10.2639L17.889 13.9C17.6336 14.1361 17.5193 14.4879 17.5871 14.829L18.6306 20.0816C18.7968 20.9186 17.9059 21.5659 17.1613 21.1491L12.4884 18.5334Z",
    fill: "#DFE6E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_6581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGray);
export default __webpack_public_path__ + "static/media/star_gray.cb143bebc664ad010d217f111eb4088d.svg";
export { ForwardRef as ReactComponent };